import CreateEnterprisePromotion from './CreateEnterprisePromotion.container';

export default CreateEnterprisePromotion;
